<template>
  <article
    class="jewel-article"
    v-bind:id="jewel.vendor_code_alias"
    itemscope
    itemtype="http://schema.org/Product"
  >
    <catalog-jewel-article-image-carousel
      v-bind:jewel="jewel"
    >
    </catalog-jewel-article-image-carousel>
    <catalog-jewel-article-description
      class="jewel-main-description"
      v-bind:jewel="jewel"
      v-on:scroll-to="scrollToElement($event)"
    >
    </catalog-jewel-article-description>
    <catalog-jewel-article-extra-description
      v-bind:ref="`${jewel.vendor_code_alias}-extra-description`"
      v-bind:jewel="jewel"
    >
    </catalog-jewel-article-extra-description>
    <catalog-jewel-article-video
      class="jewel-video"
      v-bind:ref="`${jewel.vendor_code_alias}-video`"
      v-bind:jewel="jewel"
    >
    </catalog-jewel-article-video>
  </article>
</template>

<script>
import CatalogJewelArticleImageCarousel from
  './catalog-jewel-article/CatalogJewelArticleImageCarousel'

import CatalogJewelArticleDescription from
  './catalog-jewel-article/CatalogJewelArticleDescription'

import CatalogJewelArticleExtraDescription from
  './catalog-jewel-article/CatalogJewelArticleExtraDescription'

import CatalogJewelArticleVideo from
  './catalog-jewel-article/CatalogJewelArticleVideo'

import smoothscroll from 'smoothscroll-polyfill'
// kick off the polyfill
smoothscroll.polyfill()

export default {
  name: 'CatalogJewelArticle',
  props: ['jewel'],
  components: {
    CatalogJewelArticleImageCarousel,
    CatalogJewelArticleDescription,
    CatalogJewelArticleExtraDescription,
    CatalogJewelArticleVideo
  },
  data: function () {
    return {}
  },
  methods: {
    scrollToElement: function (elementName) {
      let header = document.getElementById('js-the-header')
      let headerHeight = Math.ceil(header.getBoundingClientRect().height)

      const refName = `${this.jewel.vendor_code_alias}-${elementName}`
      let element = this.$refs[refName].$el
      window.scrollTo({
        top: element.offsetTop - headerHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .jewel-article {
    display: flex;
    @include media (">tablet") { flex-wrap: wrap; }
    @include media ("<=tablet") { flex-direction: column; };
    .jewel-main-description + .jewel-video {
      background-color: $inverse-background-color;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/CatalogJewelArticle.vue